import React from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import SetAdminPassword from "components/SetAdminPassword";
import { Container, Row, Col } from 'react-bootstrap';

const SetAdminPasswordPage = () => {
  return (
    <>  
      <LogoutHeader />
      <main className="section-spaces">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <SetAdminPassword />
            </Col>
          </Row>
        </Container> 
      </main>
      <LogoutFooter />
    </>
  );
}

export default SetAdminPasswordPage;